import { Component, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";
import { UploadSignatureComponent } from "./upload-signature/upload-signature.component";

@Component({
  selector: "app-signature",
  templateUrl: "./signature.component.html",
  styleUrls: ["./signature.component.scss"],
})
export class SignatureComponent implements OnInit {
  employee: Employee;

  constructor(
    private _router: Router,
    private _employeeService: EmployeeService,
    private _activatedRoute: ActivatedRoute,
    private modalService: NgbModal
  ) {}

  ngOnInit() {
    this.getUserInfo();
  }

  getUserInfo() {
    this._employeeService.getCurrentEmployee().subscribe(
      (data) => {
        this.employee = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  uploadSignature() {
    const modalRef = this.modalService.open(UploadSignatureComponent, {
      centered: true,
    });
    modalRef.componentInstance.username = this.employee.username;

    modalRef.result.then(
      (data) => {
        // on close

        this.getUserInfo();
      },
      (reason) => {
        // on dismiss
      }
    );
  }
}
